export default __webpack_public_path__ + "static/media/Agenda---EDSFr3-Design-Workshop-(18-19-July-2018).da6e9098.md";